import { render, staticRenderFns } from "./SelectPlano.vue?vue&type=template&id=137c4fa6"
import script from "./SelectPlano.vue?vue&type=script&lang=js"
export * from "./SelectPlano.vue?vue&type=script&lang=js"
import style0 from "./SelectPlano.vue?vue&type=style&index=0&id=137c4fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports